import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  formatAttributeLabel,
  formatPathSegments,
} from 'components/FieldColumns/columnHeader';
import PreviewTablePlaceholderRow from 'components/PreviewTablePicker/PreviewTablePlaceholderRow';

import 'components/PreviewTablePicker/PreviewTablePicker.css';
import 'components/PreviewTablePicker/ColumnPickerModal.css';

var PLACEHOLDER_ROW_COUNT = 3;
var GHOST_CELL_COUNT = 4;

/**
 * Read-only preview of a column set: header cells (path, title, attribute
 * chip) over placeholder rows. Shows ghost cells and an overlay when empty.
 */
var ColumnPreviewTable = function(props) {
  var columns = props.columns;
  var t = props.t;
  var hasColumns = columns.length > 0;

  var headerCells = hasColumns ? columns.map(function(column) {
    var attributeLabel = formatAttributeLabel(column.fieldAttribute, t);
    return (
      <div
        key={column.cuuid}
        className={classnames('column-picker-preview-header-cell', {
          'column-picker-preview-header-cell--muted': column.muted || column.locked,
        })}
      >
        <div className="column-picker-preview-column-info">
          {column.hierarchyPath && column.hierarchyPath.length > 0 && !column.meta ? (
            <span className="preview-table-column-hierarchy">
              {formatPathSegments(column.hierarchyPath)}
            </span>
          ) : (
            <span className="preview-table-column-hierarchy-spacer" />
          )}
          <div className="preview-table-column-title-row">
            <span className="preview-table-column-title">
              {column.title}
            </span>
            {attributeLabel && (
              <span className="preview-table-column-attribute">
                {attributeLabel}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }) : null;

  var ghostCells = [];
  if (!hasColumns) {
    for (var g = 0; g < GHOST_CELL_COUNT; g++) {
      ghostCells.push(
        <div key={'ghost-' + g} className="column-picker-preview-header-cell" />
      );
    }
  }

  var placeholderRows = [];
  for (var r = 0; r < PLACEHOLDER_ROW_COUNT; r++) {
    placeholderRows.push(
      <PreviewTablePlaceholderRow
        key={r}
        columns={hasColumns ? columns : undefined}
        rowIndex={r}
      />
    );
  }

  return (
    <div className={classnames('column-picker-preview', {
      'column-picker-preview--empty': !hasColumns,
    })}>
      <div className="column-picker-preview-table">
        <div className="preview-table-header">
          <div className="column-picker-preview-header-inner">
            {hasColumns ? headerCells : ghostCells}
            <div className="preview-table-header-filler" />
          </div>
        </div>
        <div className="preview-table-body">
          {placeholderRows}
        </div>
      </div>
      {!hasColumns && (
        <div className="column-picker-preview-overlay">
          <span className="material-symbols-outlined column-picker-preview-overlay-icon">
            view_column
          </span>
          <span className="column-picker-preview-overlay-text">
            {t('settings:previewEmptyMessage')}
          </span>
        </div>
      )}
    </div>
  );
};

ColumnPreviewTable.propTypes = {
  columns: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default ColumnPreviewTable;
